// extracted by mini-css-extract-plugin
module.exports = {"hop-ErrorMessage":"ErrorMessage_hop-ErrorMessage__kH2pM","hop-ErrorMessage__icon":"ErrorMessage_hop-ErrorMessage__icon__fkv2Y"};